import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Calendar, Download, Languages } from "lucide-react";
import { PageHero } from "./About";

const events = [
  {
    title: "ಕನ್ನಡ ರಾಜ್ಯೋತ್ಸವ ಆಚರಣೆ (೨೦೨೫)",
    description:
      "ಕನ್ನಡ ಭಾಷೆ, ಸಾಂಪ್ರದಾಯಿಕ ಉಡುಗೆ, ಗೀತೆಗಳು, ಸ್ಪರ್ಧೆಗಳು ಹಾಗೂ ವಿದ್ಯಾರ್ಥಿಗಳ ಸಕ್ರಿಯ ಭಾಗವಹಿಸುವಿಕೆಯ ಮೂಲಕ ಕರ್ನಾಟಕ ರಾಜ್ಯೋತ್ಸವವನ್ನು ಆಚರಿಸಿ, ಪ್ರಾದೇಶಿಕ ಸಂಸ್ಕೃತಿ ಮತ್ತು ಪರಂಪರೆಯ ಬಗ್ಗೆ ಹೆಮ್ಮೆ ಹಾಗೂ ಅರಿವನ್ನು ಬಲಪಡಿಸಿದ ಸಾಂಸ್ಕೃತಿಕ ಕಾರ್ಯಕ್ರಮ",
    report: "/Clubs/Kannada-Sangha-Kalpavruksha-Club/Kannada rajyotsava report 2025.doc",
  },
  {
    title: "ಅಂತರರಾಷ್ಟ್ರೀಯ ಮಾತೃಭಾಷಾ ದಿನಾಚರಣೆ (೨೦೨೫)",
    description:
      "ಕೃತಕ ಬುದ್ಧಿಮತ್ತೆ (Artificial Intelligence) ವಿಷಯದ ಕುರಿತ ಕನ್ನಡ ಉಪನ್ಯಾಸದ ಮೂಲಕ ಮಾತೃಭಾಷೆಯ ಮಹತ್ವವನ್ನು ಸಾರಿದ ಈ ಶೈಕ್ಷಣಿಕ ಕಾರ್ಯಕ್ರಮವು ವಿದ್ಯಾರ್ಥಿಗಳಲ್ಲಿ ನವೋತ್ಸಾಹ, ಜ್ಞಾನಾರ್ಜನೆ ಹಾಗೂ ತಾಂತ್ರಿಕ ಅರಿವನ್ನು ಬೆಳೆಸುವ ಉದ್ದೇಶವನ್ನು ಹೊಂದಿತ್ತು",
    report: "/Clubs/Kannada-Sangha-Kalpavruksha-Club/matru bhasha divas report.docx",
  },
  {
    title: "ಕನ್ನಡ ರಾಜ್ಯೋತ್ಸವ ಆಚರಣೆ (೨೦೨೪)",
    description:
      "ಸಾಂಪ್ರದಾಯಿಕ ಗೊಂಬೆಯಾಟ, ಕನ್ನಡ ಸಂಸ್ಕೃತಿ ಮತ್ತು ಇತಿಹಾಸದ ವೈಭವವನ್ನು ಬಿಂಬಿಸುವ ಪ್ರದರ್ಶನಗಳು, ವಿವಿಧ ಸ್ಪರ್ಧೆಗಳು ಹಾಗೂ ಸಮುದಾಯಮುಖಿ ಚಟುವಟಿಕೆಗಳ ಮೂಲಕ ಕನ್ನಡ ಭಾಷೆ, ಪರಂಪರೆ ಮತ್ತು ಪ್ರಾದೇಶಿಕ ಹೆಮ್ಮೆಯನ್ನು ಉತ್ತೇಜಿಸಿದ ಉತ್ಸಾಹಭರಿತ ಕನ್ನಡ ರಾಜ್ಯೋತ್ಸವ ಆಚರಣೆ",
    report: "/Clubs/Kannada-Sangha-Kalpavruksha-Club/kannada rajyotsava celebration 2024.pdf",
  },
  {
    title: "ಕನ್ನಡ ಕಾರ್ತಿಕ ಅನುದಿನ ಅನುಸ್ಪಂದನ ಕಾರ್ಯಕ್ರಮ (೨೦೨೩)",
    description:
      "೨೦೨೪ರ ನವೆಂಬರ್ ೨೫ರಂದು ಕೆ.ಎಲ್.ಎಸ್. ವಿ.ಡಿ.ಐ.ಟಿ., ಹಳಿಯಾಳದಲ್ಲಿ ಕನ್ನಡ ಕಾರ್ತಿಕ ಅನುದಿನ ಅನುಸ್ಪಂದನ ಕಾರ್ಯಕ್ರಮ ನಡೆಯಿತು. ಈ ಸಂದರ್ಭದಲ್ಲಿ ಕನ್ನಡ ಭಾಷೆ ಮತ್ತು ಸಂಸ್ಕೃತಿಯ ಮಹತ್ವವನ್ನು ಪ್ರತಿಪಾದಿಸಲಾಗಿದ್ದು, “ಕನ್ನಡ ಕಳಶ ಪ್ರಶಸ್ತಿ” ಪ್ರದಾನಿಸಲಾಯಿತು. ೧೫೦ಕ್ಕೂ ಅಧಿಕ ವಿದ್ಯಾರ್ಥಿಗಳು ಹಾಗೂ ಸಿಬ್ಬಂದಿಗಳು ಕಾರ್ಯಕ್ರಮದಲ್ಲಿ ಭಾಗವಹಿಸಿದರು.",
    report: "/Clubs/Kannada-Sangha-Kalpavruksha-Club/kartika auspandana report.doc",
  },
];

const KalpavrukshaKannadaSangha = () => (
  <main>
    <PageHero
      title="ಕಲ್ಪವೃಕ್ಷ ಕನ್ನಡ ಸಂಘ"
      sub="ಕನ್ನಡ ಭಾಷೆ, ಸಾಹಿತ್ಯ, ಸಂಸ್ಕೃತಿ ಮತ್ತು ವಿದ್ಯಾರ್ಥಿಗಳ ಸೃಜನಾತ್ಮಕ ಅಭಿವ್ಯಕ್ತಿಯನ್ನು ಸಂಭ್ರಮಿಸುವ ವೇದಿಕೆ"
      image="/Campus/kannadasanga.jpg"
    />

    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
      <Link
        to="/clubs"
        className="inline-flex items-center gap-2 text-sm font-semibold text-brand hover:underline mb-8"
      >
        <ArrowLeft size={16} />
        Back to Clubs
      </Link>

      <div className="grid lg:grid-cols-3 gap-8 items-start">
        <section className="lg:col-span-2 bg-white border border-brand/15 p-7 md:p-9">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-11 h-11 border border-brand/20 flex items-center justify-center text-brand">
              <Languages size={22} />
            </div>
            <p className="text-xs uppercase tracking-[0.24em] text-brand font-semibold">
              ಸಾಂಸ್ಕೃತಿಕ ಸಂಘ
            </p>
          </div>

          <h2
            className="text-3xl md:text-5xl text-brand font-semibold leading-tight"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            ಕನ್ನಡ ಭಾಷೆ, ಸಂಸ್ಕೃತಿ ಮತ್ತು ಸಮುದಾಯ.
          </h2>

          <p className="mt-5 text-[16px] text-[#2a2a2a]/85 leading-relaxed">
            ಕಲ್ಪವೃಕ್ಷ ಕನ್ನಡ ಸಂಘವು ಕನ್ನಡ ಭಾಷೆ, ಸಾಹಿತ್ಯ ಮತ್ತು ಸಾಂಸ್ಕೃತಿಕ ಅಸ್ತಿತ್ವವನ್ನು ಉತ್ತೇಜಿಸುವುದರೊಂದಿಗೆ, ವಿವಿಧ ಆಚರಣೆಗಳು, ಉಪನ್ಯಾಸಗಳು ಹಾಗೂ ಕ್ಯಾಂಪಸ್ ಚಟುವಟಿಕೆಗಳ ಮೂಲಕ ವಿದ್ಯಾರ್ಥಿಗಳ ಸಕ್ರಿಯ ಭಾಗವಹಿಸುವಿಕೆಯನ್ನು ಪ್ರೋತ್ಸಾಹಿಸುತ್ತದೆ
          </p>
        </section>

        <aside className="bg-brand text-white p-6 lg:sticky lg:top-32">
          <p className="text-xs uppercase tracking-[0.24em] opacity-80 font-semibold">
            ಸಂಘದ ಧ್ಯೇಯಗಳು
          </p>
          <h3
            className="text-3xl font-semibold mt-2"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            ಭಾಷೆ ಮತ್ತು ಸಂಸ್ಕೃತಿ
          </h3>
          <p className="mt-3 text-sm leading-relaxed text-white/85">
           ಕನ್ನಡ ಅಭಿವ್ಯಕ್ತಿ, ಸಾಂಸ್ಕೃತಿಕ ಜಾಗೃತಿ ಹಾಗೂ ಅರ್ಥಪೂರ್ಣ ಕ್ಯಾಂಪಸ್ ಚಟುವಟಿಕೆಗಳಿಗೆ ವಿದ್ಯಾರ್ಥಿಗಳ ವೇದಿಕೆ.

          </p>
        </aside>
      </div>

      <section className="mt-12">
        <p className="text-xs uppercase tracking-[0.24em] text-brand font-semibold mb-4">
          Events
        </p>
        <div className="grid md:grid-cols-2 gap-5">
          {events.map((event) => (
            <article key={event.title} className="bg-white border border-brand/15 p-5">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 border border-brand/20 flex items-center justify-center text-brand flex-shrink-0">
                  <Calendar size={18} />
                </div>
                <div>
                  <h3 className="text-xl text-brand font-semibold leading-snug">
                    {event.title}
                  </h3>
                  <p className="text-sm text-[#2a2a2a]/85 leading-relaxed mt-2">
                    {event.description}
                  </p>
                  <a
                    href={event.report}
                    download
                    className="inline-flex items-center gap-2 mt-4 bg-brand text-white px-4 py-2 text-xs font-semibold tracking-wider uppercase hover:bg-brand-dark transition"
                  >
                    <Download size={14} />
                    Download full report
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </section>
  </main>
);

export default KalpavrukshaKannadaSangha;